import { CambiaClaveComponent } from './core/components/cambia-clave/cambia-clave.component';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { UsuarioGuard } from './guards/usuario.guard';
import { CambiaCLGuard } from './guards/cambia-cl.guard';

import { LoginComponent } from './core/components/login/login.component';
import { InicioComponent } from './core/components/inicio/inicio.component';
import { CtrlCasosComponent } from './core/components/ctrl-casos/ctrl-casos.component';
import { SistemasComponent } from './core/components/sistemas/sistemas.component';
import { VisitasClienteComponent } from './core/components/visitas-cliente/visitas-cliente.component';
import { Error404Component } from './core/components/error404/error404.component';


const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', component: InicioComponent, canActivate: [ UsuarioGuard ] },
  { path: 'casos', component: CtrlCasosComponent, canActivate: [ UsuarioGuard ]},
  { path: 'mejoras', component: SistemasComponent, canActivate: [ UsuarioGuard ] },
  { path: 'cambiacl', component: CambiaClaveComponent, canActivate: [ CambiaCLGuard ] },
  { path: 'visitasCliente', component: VisitasClienteComponent, canActivate: [ UsuarioGuard ] },
  { path: '**', component: Error404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


